var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("x-grid", {
            ref: "grid",
            attrs: {
              id: "formList",
              rowId: _vm.rowId,
              "pager-config": _vm.pagerConfig,
              "form-config": _vm.formConfig,
              url: _vm.url,
              columns: _vm.columns,
              "checkbox-config": _vm.checkboxConfig,
              "toolbar-config": _vm.toolbarConfig,
              "print-config": _vm.printConfig,
              "export-config": _vm.exportConfig,
              "other-params": {
                startDate: _vm.startDate,
                endDate: _vm.endDate,
                isNotFollow: _vm.isNotFollow,
                isTodayFollow: _vm.isTodayFollow,
                fromIndexParam: _vm.fromIndexParam,
                deptId: _vm.deptId, //followUserId,regionId,dealerId,
              },
              cellClick: _vm.chooseRow,
              cellDbClick: _vm.updateRow,
            },
            on: {
              "toolbar-addData": _vm.addRow,
              "toolbar-delData": _vm.delRow,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: _vm.toolbarConfig.templatelSlots,
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "formModal",
        {
          attrs: {
            title: "线索管理详情",
            centered: "",
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 1200,
            closable: true,
          },
          on: { cancelled: _vm.closeDetailPop },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }